import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="border-t border-border bg-card">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-3 font-quicksand font-bold text-xl bg-gradient-to-r from-secondary via-primary to-accent bg-clip-text text-transparent hover:opacity-90 transition-all duration-300">
              <img 
                src="/images/logo-tiny-tax-lady.png" 
                alt="Tiny Tax Lady" 
                className="h-10 w-10 rounded-full object-cover ring-2 ring-secondary/30 ring-offset-2 shadow-lg"
              />
              <span>Tiny Tax Lady</span>
            </Link>
            <p className="text-sm text-muted-foreground">
              Diane Hardesty - Your trusted tax professional with 38 years of expertise in individual and sole proprietor tax preparation. Serving families and small businesses throughout Lenexa and the Kansas City metro area with personalized, year-round tax support.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Tax Menu</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-muted-foreground hover:text-secondary transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-muted-foreground hover:text-secondary transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-muted-foreground hover:text-secondary transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-muted-foreground hover:text-secondary transition-colors">
                  FAQ & Pricing
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Services</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>Individual Tax Returns</li>
              <li>Sole Proprietor Filing</li>
              <li>Amended Returns</li>
              <li>Year-Round Support</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-secondary mt-0.5 flex-shrink-0" />
                <a 
                  href="https://www.google.com/maps/search/?api=1&query=9330+Gillette+St+Lenexa+KS+66215"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-muted-foreground hover:text-secondary transition-colors"
                >
                  9330 Gillette St.<br />Lenexa, KS 66215
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-secondary flex-shrink-0" />
                <a href="tel:913-406-7852" className="text-sm text-muted-foreground hover:text-secondary transition-colors">
                  913-406-7852
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-secondary flex-shrink-0" />
                <span className="text-sm text-muted-foreground">
                  Fax: 913-271-4416
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-secondary flex-shrink-0" />
                <a href="mailto:Diane@TinyTaxLady.com" className="text-sm text-muted-foreground hover:text-secondary transition-colors break-all">
                  Diane@TinyTaxLady.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
            {/* Left/Center: Copyright text */}
            <div className="text-center">
              <p className="text-sm text-muted-foreground">
                Serving Lenexa, Overland Park, Shawnee, and the Kansas City metro.
              </p>
              <p className="text-sm text-muted-foreground mt-2">
                © {new Date().getFullYear()} Tiny Tax Lady. All rights reserved.
              </p>
              <div className="flex items-center justify-center gap-4 mt-3">
                <Link 
                  to="/terms" 
                  className="text-xs text-muted-foreground hover:text-secondary transition-colors underline"
                >
                  Terms & Conditions
                </Link>
                <span className="text-xs text-muted-foreground">•</span>
                <Link 
                  to="/privacy" 
                  className="text-xs text-muted-foreground hover:text-secondary transition-colors underline"
                >
                  Privacy Policy
                </Link>
                <span className="text-xs text-muted-foreground">•</span>
                <Link 
                  to="/link-partners" 
                  className="text-xs text-muted-foreground hover:text-secondary transition-colors underline"
                >
                  Link Partners
                </Link>
              </div>
            </div>
            
            {/* Right: Partner Logos */}
            <div className="flex-shrink-0 flex items-center gap-4">
              {/* AWS Badge */}
              <img 
                src="/images/aws-certified.jpg" 
                alt="AWS Certified Cloud Practitioner" 
                className="h-20 w-auto opacity-90"
              />
              
              {/* QuickMorph Logo - Clickable */}
              <a 
                href="https://www.quickmorph.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity"
              >
                <img 
                  src="/images/quickmorph-logo.png" 
                  alt="QuickMorph" 
                  className="h-20 w-auto opacity-90"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
